// extracted by mini-css-extract-plugin
export var slider = "Reviews-module--slider--VI+Ou";
export var wrapper = "Reviews-module--wrapper--Ldw2v";